import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../../styles/icons/base.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function NhlMolson({ className }) {
    return (
        <svg
            className={classNames([styles.container, { [className]: className !== null }])}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={190.7}
            height={174.6}
            viewBox="0 0 190.7 174.6"
        >
            <g id="Groupe_815" transform="translate(1431.234 1446.804)">
                <path
                    id="Tracé_1589"
                    fill="#A71421"
                    d="M-1368.8-1286.3c3.1,0.1,6-1.6,7.6-4.3c3.5-5.9,9.9-16.3,16.1-26.6
		c6-9.8,11.9-19.6,15.3-25.2c0.1-0.2,0.2-0.3,0.3-0.5l0-0.1l1.1-2.2l-11.3-6.8l-1.5,2.4c-0.1,0.1-0.2,0.3-0.3,0.4
		c-2.3,3.8-6.8,11.1-11.4,18.7c-5.8,9.6-11.9,19.5-14.8,24.2c-0.8,1.6-2.5,2.6-4.2,2.6c-0.5,0-1-0.1-1.5-0.2
		c-2.4-0.6-5.2-1.2-7.9-1.9c-0.1,0-0.2,0-0.3-0.1l-2.5-0.6c-0.1,0-0.1,0-0.2-0.1l-2-0.5c-1.3-0.3-2.7-0.6-4-1
		c-0.5-0.1-0.9-0.2-1.4-0.2c-2.1,0-3.9,1.3-4.6,3.2c-1.2,2.9-2.8,6.8-4.3,10.6c-0.6,1.5-0.5,3.2,0.3,4.6c0.9,1.4,2.4,2.2,4,2.3
		c1,0.1,2.1,0.1,3,0.1l23.9,1.1C-1369.2-1286.3-1369-1286.3-1368.8-1286.3z"
                />
                <path
                    id="Tracé_1590"
                    fill="#A71421"
                    d="M-1299.9-1286.3c-3.1,0.1-6-1.6-7.6-4.3c-3.5-5.9-9.9-16.3-16.1-26.6
		c-6-9.8-11.9-19.6-15.3-25.2c-0.1-0.2-0.2-0.3-0.3-0.5l0-0.1l-1.1-2.2l11.3-6.8l1.5,2.4c0.1,0.1,0.2,0.3,0.3,0.4
		c2.3,3.8,6.8,11.1,11.4,18.7c5.8,9.6,11.9,19.5,14.8,24.2c0.8,1.6,2.5,2.6,4.2,2.6c0.5,0,1-0.1,1.5-0.2c2.4-0.6,5.2-1.2,7.9-1.9
		c0.1,0,0.2,0,0.3-0.1l2.5-0.6c0.1,0,0.1,0,0.2-0.1l2-0.5c1.3-0.3,2.7-0.6,4-1c0.5-0.1,0.9-0.2,1.4-0.2c2.1,0,3.9,1.3,4.6,3.2
		c1.2,2.9,2.8,6.8,4.3,10.6c0.7,1.5,0.5,3.2-0.3,4.6c-0.9,1.4-2.4,2.2-4,2.3c-1,0.1-2.1,0.1-3,0.1l-23.9,1.1
		C-1299.6-1286.3-1299.8-1286.3-1299.9-1286.3z"
                />
                <path
                    id="Tracé_1591"
                    fill="#A71421"
                    d="M-1334.7-1272.2c-2.2,0-4.4-0.6-6.4-1.7l-75.3-43.5v-94h10.9v87.7l69.9,40.4
		c0.3,0.2,0.6,0.3,1,0.3c0.3,0,0.7-0.1,1-0.3l69.9-40.4v-87.7h10.9v94l-75.3,43.5C-1330.3-1272.8-1332.5-1272.2-1334.7-1272.2
		L-1334.7-1272.2z"
                />
                <path
                    id="Tracé_1592"
                    fill="#1B2F5F"
                    d="M-1334.7-1274.9c-1.8,0-3.5-0.5-5-1.3l-74-42.7v-89.7h5.4v86.5l71.3,41.1
		c1.4,0.8,3.2,0.8,4.6,0l71.3-41.1v-86.5h5.4v89.7l-74,42.7C-1331.2-1275.4-1332.9-1274.9-1334.7-1274.9z"
                />
                <path
                    id="Tracé_1593"
                    fill="#FFFFFF"
                    d="M-1411-1408.7v88.1l72.6,41.9c2.3,1.3,5.1,1.3,7.4,0l72.6-41.9v-88.1"
                />
                <g id="Groupe_802" transform="translate(-1405.268 -1327.941)">
                    <linearGradient
                        id="Tracé_1594_00000024708997343884129270000016295071059248396166_"
                        gradientUnits="userSpaceOnUse"
                        x1="-887.4166"
                        y1="503.9337"
                        x2="-887.4166"
                        y2="504.9337"
                        gradientTransform="matrix(141.4741 0 0 -47.8972 125617.2266 24184.9199)"
                    >
                        <stop offset="0" style={{ stopColor: '#FFFFFF', stopOpacity: 0 }} />
                        <stop offset="1" style={{ stopColor: '#A71421', stopOpacity: 0.4 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1594"
                        fill="url(#Tracé_1594_00000024708997343884129270000016295071059248396166_)"
                        d="M68.9,0
			C42.6,0,18.5,2.4,0,6.4v1.8L67.3,47c2.1,1.2,4.7,1.2,6.8,0l67.3-38.9V7.2C122.6,2.7,97,0,68.9,0z"
                    />
                </g>

                <linearGradient
                    id="Tracé_1595_00000145752212100877391850000001447767478937861028_"
                    gradientUnits="userSpaceOnUse"
                    x1="-2292.252"
                    y1="-824.9342"
                    x2="-2292.252"
                    y2="-823.9342"
                    gradientTransform="matrix(117.5071 0 0 -39.7831 268021.625 -34103.3477)"
                >
                    <stop offset="0" style={{ stopColor: '#FFFFFF', stopOpacity:0 }} />
                    <stop offset="1" style={{ stopColor: '#A71421', stopOpacity:0.4 }} />
                </linearGradient>
                <path
                    id="Tracé_1595"
                    fill="url(#Tracé_1595_00000145752212100877391850000001447767478937861028_)"
                    d="M-1335.7-1324.7
		c-21.9,0-41.9,2-57.2,5.3v1.5l55.9,32.3c1.8,1,3.9,1,5.7,0l55.9-32.3v-0.8C-1291.1-1322.4-1312.4-1324.7-1335.7-1324.7z"
                />

                <linearGradient
                    id="Tracé_1596_00000178178252066392599800000010705299143121974459_"
                    gradientUnits="userSpaceOnUse"
                    x1="-2291.4812"
                    y1="-826.586"
                    x2="-2291.4812"
                    y2="-825.586"
                    gradientTransform="matrix(90.2609 0 0 -30.5576 205495.7812 -26548.4902)"
                >
                    <stop offset="0" style={{ stopColor: '#FFFFFF', stopOpacity:0 }} />
                    <stop offset="1" style={{ stopColor: '#A71421', stopOpacity:0.4 }} />
                </linearGradient>
                <path
                    id="Tracé_1596"
                    fill="url(#Tracé_1596_00000178178252066392599800000010705299143121974459_)"
                    d="M-1290.1-1316v0.6
		l-43,24.8c-1.3,0.8-3,0.8-4.4,0l-43-24.8v-1.1c11.8-2.5,27.2-4.1,44-4.1C-1318.5-1320.5-1302.2-1318.8-1290.1-1316z"
                />
                <g id="Groupe_804" transform="translate(-1336.752 -1348.469)">
                    <path
                        id="Tracé_1597"
                        fill="#1B2F5F"
                        d="M6.9,0c0.1,0.2,0.3,0.4,0.4,0.6C12.5,9,28.2,35,33.4,43.4c1.7,3.1,5.3,4.6,8.7,3.6
			c2.6-0.6,5.3-1.2,7.9-1.9c0.1,0,0.1,0,0.2,0l2.7-0.6c0.1,0,0.1,0,0.2,0c2-0.5,4-0.9,6-1.4c1.2-0.4,2.4,0.2,2.8,1.4
			c1.4,3.5,2.9,7,4.3,10.6c0.5,1.1,0.1,2.4-1,3c-0.3,0.2-0.7,0.2-1,0.2c-1,0.1-2,0.1-3,0.1l-9,0.4l0,0l-14.9,0.7
			c-2.3,0.2-4.5-1-5.6-3C24.7,45,7.1,16.1,0.2,4.6C0.1,4.5,0.1,4.3,0,4.2L6.9,0z"
                    />
                    <g>
                        <defs>
                            <path
                                id="SVGID_1_"
                                d="M6.9,0c0.1,0.2,0.3,0.4,0.4,0.6C12.5,9,28.2,35,33.4,43.4c1.7,3.1,5.3,4.6,8.7,3.6
					c2.6-0.6,5.3-1.2,7.9-1.9c0.1,0,0.1,0,0.2,0l2.7-0.6c0.1,0,0.1,0,0.2,0c2-0.5,4-0.9,6-1.4c1.2-0.4,2.4,0.2,2.8,1.4
					c1.4,3.5,2.9,7,4.3,10.6c0.5,1.1,0.1,2.4-1,3c-0.3,0.2-0.7,0.2-1,0.2c-1,0.1-2,0.1-3,0.1l-9,0.4l0,0l-14.9,0.7
					c-2.3,0.2-4.5-1-5.6-3C24.7,45,7.1,16.1,0.2,4.6C0.1,4.5,0.1,4.3,0,4.2L6.9,0z"
                            />
                        </defs>
                        <clipPath id="SVGID_00000169516945499645373650000011575598373913911220_">
                            <use xlinkHref="#SVGID_1_" overflow="visible" />
                        </clipPath>
                        <g
                            id="Groupe_803"
                            transform="translate(0)"
                            clipPath="url(#SVGID_00000169516945499645373650000011575598373913911220_)"
                        >
                            <path
                                id="Tracé_1598"
                                fill="#508FEA"
                                d="M74,30.2c1.5-0.4,3.5-0.5,4.1,1"
                            />
                        </g>
                    </g>
                </g>
                <g id="Groupe_806" transform="translate(-1335.534 -1347.908)">
                    <path id="Tracé_1600" fill="#FFFFFF" d="M50.9,58.2" />

                    <linearGradient
                        id="Tracé_1601_00000181799676800369098740000014287512357952880552_"
                        gradientUnits="userSpaceOnUse"
                        x1="-954.6639"
                        y1="524.7147"
                        x2="-954.6639"
                        y2="525.7147"
                        gradientTransform="matrix(65.1248 0 0 -58.3506 62204.8203 30675.7637)"
                    >
                        <stop offset="0.275" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1601"
                        fill="url(#Tracé_1601_00000181799676800369098740000014287512357952880552_)"
                        d="M6.1,0
			c5.2,8.5,21,34.4,26.2,42.9c1.7,3.1,5.3,4.6,8.7,3.6c2.6-0.6,5.3-1.2,7.9-1.9c0.1,0,0.1,0,0.2,0l2.7-0.6c0.1,0,0.1,0,0.2,0
			c2-0.5,4-0.9,6-1.4c1.2-0.4,2.4,0.2,2.8,1.4c1.4,3.5,2.9,7,4.3,10.6c0.5,1.1,0.1,2.4-1,3c-0.3,0.2-0.7,0.2-1,0.2l-26.6,0.7
			c-2.5,0.1-3.8-1.4-5.1-3.5L0,2.9"
                    />
                    <g>
                        <defs>
                            <path
                                id="SVGID_00000080199334069354637620000014281366883696797065_"
                                d="M31.2,54.8L0,2.9L6.1,0c5.2,8.5,21,34.4,26.2,42.9
					c1.7,3.1,5.3,4.6,8.7,3.6c2.6-0.6,5.3-1.2,7.9-1.9c0.1,0,0.1,0,0.2,0l2.7-0.6c0.1,0,0.1,0,0.2,0c2-0.5,4-0.9,6-1.4
					c1.2-0.4,2.4,0.2,2.8,1.4c1.4,3.5,2.9,7.1,4.3,10.6c0.5,1.1,0.1,2.4-1,3c-0.3,0.2-0.7,0.2-1,0.2l-26.6,0.7c-0.1,0-0.2,0-0.2,0
					C33.8,58.4,32.4,56.9,31.2,54.8z"
                            />
                        </defs>
                        <clipPath id="SVGID_00000157296401207836073730000006110407118321742253_">
                            <use
                                xlinkHref="#SVGID_00000080199334069354637620000014281366883696797065_"
                                overflow="visible"
                            />
                        </clipPath>
                        <g
                            id="Groupe_805"
                            transform="translate(0 0)"
                            clipPath="url(#SVGID_00000157296401207836073730000006110407118321742253_)"
                        >
                            <linearGradient
                                id="Tracé_1602_00000160911910384442173540000017102700441758361532_"
                                gradientUnits="userSpaceOnUse"
                                x1="-886.1906"
                                y1="349.8154"
                                x2="-886.1906"
                                y2="350.8154"
                                gradientTransform="matrix(4.106 0 0 -1.2185 3713.5256 456.8871)"
                            >
                                <stop offset="0.275" style={{ stopColor: '#1B2F5F' }}  />
                                <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                            </linearGradient>
                            <path
                                id="Tracé_1602"
                                fill="url(#Tracé_1602_00000160911910384442173540000017102700441758361532_)"
                                d="M72.8,29.7
					c1.5-0.4,3.5-0.5,4.1,1"
                            />
                        </g>
                    </g>
                </g>
                <g id="Groupe_808" transform="translate(-1398.326 -1348.469)">
                    <path
                        id="Tracé_1605"
                        fill="#1B2F5F"
                        d="M59.4,0c-0.1,0.2-0.2,0.4-0.4,0.6C53.9,9,38.1,35,32.9,43.4c-1.7,3.1-5.3,4.6-8.7,3.6
			c-2.6-0.6-5.3-1.2-7.9-1.9c-0.1,0-0.1,0-0.2,0l-2.7-0.6c-0.1,0-0.1,0-0.2,0c-2-0.5-4-0.9-6-1.4c-1.2-0.4-2.4,0.2-2.8,1.4
			c-1.4,3.5-2.9,7-4.3,10.6c-0.5,1.1-0.1,2.4,1,3c0.3,0.2,0.7,0.2,1,0.2c1,0.1,2,0.1,3,0.1l9,0.4l0,0l14.9,0.7c2.3,0.2,4.5-1,5.6-3
			C41.6,45,59.2,16.1,66.1,4.6c0.1-0.1,0.1-0.3,0.2-0.4L59.4,0z"
                    />
                    <g>
                        <defs>
                            <path
                                id="SVGID_00000054967617053004942490000018003513727104850592_"
                                d="M59.4,0c-0.1,0.2-0.2,0.4-0.4,0.6
					C53.9,9,38.1,35,32.9,43.4c-1.7,3.1-5.3,4.6-8.7,3.6c-2.6-0.6-5.3-1.2-7.9-1.9c-0.1,0-0.1,0-0.2,0l-2.7-0.6c-0.1,0-0.1,0-0.2,0
					c-2-0.5-4-0.9-6-1.4c-1.2-0.4-2.4,0.2-2.8,1.4c-1.4,3.5-2.9,7-4.3,10.6c-0.5,1.1-0.1,2.4,1,3c0.3,0.2,0.7,0.2,1,0.2
					c1,0.1,2,0.1,3,0.1l9,0.4l0,0l14.9,0.7c2.3,0.2,4.5-1,5.6-3C41.6,45,59.2,16.1,66.1,4.6c0.1-0.1,0.1-0.3,0.2-0.4L59.4,0z"
                            />
                        </defs>
                        <clipPath id="SVGID_00000167385415761785155910000004316214009026827927_">
                            <use
                                xlinkHref="#SVGID_00000054967617053004942490000018003513727104850592_"
                                overflow="visible"
                            />
                        </clipPath>
                        <g
                            id="Groupe_807"
                            transform="translate(0)"
                            clipPath="url(#SVGID_00000167385415761785155910000004316214009026827927_)"
                        >
                            <path
                                id="Tracé_1606"
                                fill="#508FEA"
                                d="M-7.7,30.2c-1.5-0.4-3.5-0.5-4.1,1"
                            />
                        </g>
                    </g>
                </g>
                <g id="Groupe_810" transform="translate(-1398.326 -1347.908)">
                    <path id="Tracé_1608" fill="#FFFFFF" d="M14.2,58.2" />

                    <linearGradient
                        id="Tracé_1609_00000098943756442836668170000009812364033421270965_"
                        gradientUnits="userSpaceOnUse"
                        x1="-891.8722"
                        y1="524.7147"
                        x2="-891.8722"
                        y2="525.7147"
                        gradientTransform="matrix(65.1288 0 0 -58.3506 58119.0938 30675.7637)"
                    >
                        <stop offset="0.275" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1609"
                        fill="url(#Tracé_1609_00000098943756442836668170000009812364033421270965_)"
                        d="M59.1,0
			c-5.2,8.5-21,34.4-26.2,42.9c-1.7,3.1-5.3,4.6-8.7,3.6c-2.6-0.6-5.3-1.2-7.9-1.9c-0.1,0-0.1,0-0.2,0l-2.7-0.6c-0.1,0-0.1,0-0.2,0
			c-2-0.5-4-0.9-6-1.4c-1.2-0.4-2.4,0.2-2.8,1.4c-1.4,3.5-2.9,7-4.3,10.6c-0.5,1.1-0.1,2.4,1,3c0.3,0.2,0.7,0.2,1,0.2l26.6,0.7
			c2.5,0.1,3.8-1.4,5.1-3.5L65.1,2.9"
                    />
                    <g>
                        <defs>
                            <path
                                id="SVGID_00000042001131261851847110000011713246294022838186_"
                                d="M28.8,58.4L2.2,57.6c-1.2,0-2.2-1-2.2-2.2
					c0-0.4,0.1-0.7,0.2-1c1.4-3.5,2.9-7.1,4.3-10.6c0.4-1.2,1.7-1.8,2.8-1.4c2,0.5,4,1,6,1.4c0.1,0,0.1,0,0.2,0l2.7,0.6
					c0.1,0,0.1,0,0.2,0c2.6,0.7,5.3,1.3,7.9,1.9c3.4,1,7-0.5,8.7-3.6c5.2-8.5,21-34.4,26.2-42.9l6.1,2.9L33.9,54.8
					c-1.2,2-2.6,3.5-4.9,3.5C29,58.4,28.9,58.4,28.8,58.4z"
                            />
                        </defs>
                        <clipPath id="SVGID_00000106851043567834487500000015809579531772235172_">
                            <use
                                xlinkHref="#SVGID_00000042001131261851847110000011713246294022838186_"
                                overflow="visible"
                            />
                        </clipPath>
                        <g
                            id="Groupe_809"
                            transform="translate(0 0)"
                            clipPath="url(#SVGID_00000106851043567834487500000015809579531772235172_)"
                        >
                            <linearGradient
                                id="Tracé_1610_00000029737543103108342840000004644946563755732141_"
                                gradientUnits="userSpaceOnUse"
                                x1="-823.3801"
                                y1="349.8154"
                                x2="-823.3801"
                                y2="350.8154"
                                gradientTransform="matrix(4.105 0 0 -1.2185 3370.2559 456.8871)"
                            >
                                <stop offset="0.275" style={{ stopColor: '#1B2F5F' }}  />
                                <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                            </linearGradient>
                            <path
                                id="Tracé_1610"
                                fill="url(#Tracé_1610_00000029737543103108342840000004644946563755732141_)"
                                d="M-7.7,29.7
					c-1.5-0.4-3.5-0.5-4.1,1"
                            />
                        </g>
                    </g>
                </g>
                <path
                    id="Tracé_1613"
                    fill="#1B2F5F"
                    d="M-1357.2-1289.5l-20.8-12l-1.6,2.2l23.8,13.8L-1357.2-1289.5z"
                />
                <path
                    id="Tracé_1614"
                    fill="#1B2F5F"
                    d="M-1336.7-1329.3c37,0,69.9,4.4,90.7,11.2v-48h-179.8v47.5
		C-1405-1325.1-1372.8-1329.3-1336.7-1329.3z"
                />
                <path
                    id="Tracé_1615"
                    fill="#A71421"
                    d="M-1247.7-1319.9c-21.2-6.9-53.6-10.9-89-10.9c-34.4,0-66.3,3.8-87.5,10.4l-7,2.2v-60.3
		h13.2l0-37.9c-0.1-3.9,1.4-7.7,4.2-10.5c2.9-2.9,6.9-4.5,11-4.4h53l10.3-15.5h38.4l9.9,15.5h23.6c4.3-0.1,8.5,1.7,11.5,4.8
		c2.6,2.9,4,6.7,3.7,10.6l0.1,37.4h11.9v60.9L-1247.7-1319.9z"
                />
                <path
                    id="Tracé_1616"
                    fill="#1B2F5F"
                    d="M-1246.8-1322.5c-21.5-7-54.2-11.1-89.9-11.1c-34.7,0-66.9,3.8-88.3,10.6l-3.5,1.1v-53.9
		h13.2l0-40.6c-0.1-3.2,1.2-6.3,3.4-8.6c2.4-2.4,5.7-3.7,9-3.6h54.5l10.3-15.5h35.5l9.9,15.5h25.1c3.6-0.1,7,1.4,9.5,4
		c2.1,2.3,3.2,5.5,2.9,8.7l0.1,40.2h11.9v54.4L-1246.8-1322.5z"
                />
                <path
                    id="Tracé_1617"
                    fill="#FFFFFF"
                    d="M-1257.8-1373l-0.1-43c0.5-5.3-3.7-9.8-9.7-9.8h-26.6l-9.9-15.5h-32.6l-10.3,15.5h-55.9
		c-5.2-0.2-9.5,3.8-9.7,9c0,0.2,0,0.3,0,0.5l0,43.4h-13.2v47.5c20.8-6.5,53-10.7,89.1-10.7c37,0,69.9,4.4,90.7,11.2v-48
		L-1257.8-1373z"
                />
                <g id="Groupe_811" transform="translate(-1401.04 -1433.895)">
                    <path
                        id="Tracé_1618"
                        fill="#A71421"
                        d="M86.5,20.6l-0.4,0.8c0,0-0.1,0.1-0.1,0.1h-1c0,0-0.1,0-0.1-0.1l-3.3-5.6
			c-0.3-0.5-0.7-0.7-1.3-0.8h-8.2l-0.7-0.5c-0.1,0-0.1-0.1,0-0.2c0,0,0,0,0,0l0.7-0.6h9.8c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0.1,0.5,0.2
			c0.1,0.1,0.1,0.1,0.2,0.2l1.2,2l1.5,2.6c0.2,0.4,0.7,1.2,1,1.6C86.5,20.5,86.5,20.6,86.5,20.6 M96.6,18.9L88.9,5.7
			c-0.4-0.6-1-1-1.7-1H72.2c-0.7,0-1.4,0.4-1.7,1l-5.1,8.8c-0.5,0.9-0.5,2,0,2.9l1.8,3c2.7-2.7,4.9-3.3,6.2-2.8
			c0.6,0.3,1,0.9,1.1,1.5c0.3,1.1,0.6,4-2.5,9.3l0.9,1.5c0.5,0.7,1.4,1.1,2.3,1.2c0,0,0.4,0,0.9,0c1.2-1.7,1.7-2.1,2.8-2.1
			c0.4,0,0.8,0.1,1.1,0.4c0.2,0.4,0,0.9-0.1,1.2c0,0,0,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.1,0.3c3,0,6.5,0,7.9,0
			c0.5-0.9,1.2-1.6,2-2.3c0.9-0.8,2.1-1.3,3.3-1.5l3.6-6.4C96.9,20.2,96.9,19.5,96.6,18.9"
                    />
                    <path
                        id="Tracé_1619"
                        fill="#1B2F5F"
                        d="M33.6,62c-0.2,0-0.3-0.1-0.4-0.3c-0.5-0.8-0.8-1.7-0.9-2.6c-0.4-2.1-0.4-4.3,0-6.4
			c1.6-9.1,7.4-23.1,7.5-23.6c0-0.2,0-0.3-0.1-0.3c0,0-0.1,0-0.1,0.1c-0.2,0.2-1.5,1.8-1.9,2.4c-0.8,1.1-1.5,2.2-2.2,3.4
			c-1.7,2.7-3.3,5.4-5,8.2c-0.7,1.2-1.4,2.3-2,3.5c-0.4,0.6-0.7,1.3-1,2c-0.4,0.9-0.9,1.7-1.6,2.4c-0.3,0.3-0.8,0.5-1.3,0.5
			c-0.4,0-0.7-0.1-1.1-0.3c-0.8-0.3-1.4-0.8-2-1.4c-0.8-1.1,0.2-2.8,0.6-3.9c1.5-4.1,3.1-8.2,4.6-12.3c0.5-1.3,0.9-2.6,1.3-4
			c0.2-0.6,0.3-1.1,0.4-1.7c0-0.2-0.1-0.3-0.2-0.3c-0.1,0-0.2,0.1-0.3,0.1c-1,1-1.8,2.1-2.6,3.2c-1.1,1.5-2.2,3-3.2,4.6
			c-2.1,3.1-4.1,6.3-6.1,9.5c-0.8,1.3-1.6,2.6-2.4,3.9c-0.5,0.8-0.9,1.6-1.4,2.4c-0.3,0.7-0.7,1.3-1.3,1.8c-0.2,0.1-0.4,0.2-0.7,0.2
			c-0.5,0-0.9-0.2-1.3-0.5c-0.7-0.3-1.2-0.9-1.3-1.6c0-0.7,0.3-1.5,0.7-2.1C9,47.9,9.5,47,10,46c3.2-6.3,6.4-12.8,7.1-19.9
			c0-0.1,0-0.5,0.1-0.9c-1.6,1.8-10.2,8.1-14,9.5c-0.5,0.2-1,0.4-1.5,0.4c-0.3,0-0.6-0.1-0.8-0.3c-0.5-0.5-0.8-1.2-0.7-1.9
			c0.1-0.8,0.5-1.5,1.1-2c1.2-1.1,2.4-2.1,3.7-3c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0.1c0.1,0.3-0.3,1.4-0.1,1.6
			c0,0.1,0.1,0.1,0.2,0.1c1,0,5.3-3.5,5.7-3.8c2.1-1.7,4.1-3.6,6-5.7c0.3-0.5,0.9-0.9,1.5-1c0.1,0,0.2,0,0.3,0
			c0.5,0.1,1,0.4,1.3,0.8c0.5,0.5,0.9,1.2,1,1.9c0.2,1.2,0.1,2.4-0.1,3.6c-0.1,1.1-0.3,2.3-0.6,3.4c-0.2,1.1-0.5,2.1-0.7,3.2
			c0,0.1,0,0.2,0,0.2s0.1-0.1,0.1-0.1c0.9-1.4,6-8.5,7-9.7c1-1.3,2.1-2.5,3.4-3.5c0.2-0.1,0.4-0.2,0.6-0.2c1.4,0,3.4,1.6,3.1,3.2
			c-0.2,1.1-0.5,2.3-0.9,3.4c-0.4,1.3-0.8,2.7-1.2,4c-0.4,1.3-0.8,2.6-1.2,3.9c-0.2,0.5-0.7,2.4-0.8,2.9c-0.1,0.2,0,0.3,0,0.3
			s0.1-0.1,0.2-0.2c0.4-0.6,0.7-1.2,1.1-1.8c0.4-0.7,0.8-1.3,1.2-2c2.2-3.6,4.6-7,7.2-10.3c1.1-1.3,2.2-2.6,3.5-3.8
			c0.5-0.6,1.1-1,1.9-1.4c0.2-0.1,0.3-0.1,0.5-0.1c0.6,0.1,1.2,0.4,1.6,0.9c0.6,0.6,1.1,1.3,1.3,2.1c0.1,0.8-0.1,1.5-0.5,2.2
			c-2.8,6.3-5.5,12.7-7.7,19.3c-0.8,2.3-1.4,4.7-1.8,7.2c-0.1,0.5-0.6,2.6,0.2,2.8c0,0,0.1,0,0.1,0c0.2,0,0.3-0.1,0.4-0.2
			c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.2,0,0.2,0.1c0.4,0.3,0.7,0.7,0.7,1.2c0,0.6-0.2,1.1-0.6,1.5c-0.3,0.4-0.5,0.8-0.8,1.1
			c-0.4,0.6-0.8,1.2-1.3,1.8c-1,1.4-1.9,2.7-2.9,4C34.4,61.4,34,62,33.6,62"
                    />
                    <path
                        id="Tracé_1620"
                        fill="#1B2F5F"
                        d="M47.7,48.6c-1,0-1.9-0.3-2.7-0.8c-2-1.3-3.5-4.5-1.8-9.4c2.1-6,5.6-6.8,7.4-6.8
			c0.3,0,0.7,0,1,0.1c1.2,0.1,2.1,1.1,2.3,2.2c0,0.4,0,0.6,0,0.7c0.4,0.3,0.8,0.7,1,1.1c0.3,0.4,0.5,0.9,0.6,1.4c0,0,0,0.1,0.1,0.1
			c0.4,0,0.8-0.1,1.1-0.1c0.4-0.1,0.9-0.2,1.2-0.4c0,0,0,0,0,0c0.8-4.6,2.5-9,5.1-12.9c1-1.6,2.2-3.1,3.5-4.4l0.6,1.1
			c2.1-2.1,3.9-2.9,5.2-2.9c0.2,0,0.4,0,0.5,0c0.2,0.3,0.4,0.6,0.5,1c0.4,1.3,0.7,5-4.1,11.8c-4.2,6-6.2,7.3-7.1,7.9l-0.1,0.1
			c0,0,0,0,0,0.1c0,0.6-0.1,2.6,1.4,3.2c0.2,0.1,0.5,0.2,0.7,0.2c1.8,0,4.4-2.3,7.7-6.9c1-1.4,1.8-2.5,2.4-3.4l0.4-0.5
			c0.2,0,0.4,0.1,0.6,0.1c0,0,0.4,0,0.9,0c1.2-1.7,1.7-2.1,2.7-2.1h0.1H79c0,0.3,0,0.7-0.2,1c0,0,0,0.1-0.1,0.1c0,0,0,0.1,0,0.1
			c-0.1,0.2-0.3,0.8,0.5,2.3c0.4,0.8,0.8,1.5,1.1,2.1c0.4,0.7,0.8,1.4,1.1,2.2c0.2,0.4,0.2,0.7,0.3,0.8c0,0,0,0.1,0,0.1
			c1.2-0.6,2.2-1.6,3-2.7c0-0.1,0.1-0.3,0.1-0.5c0.3-1.2,0.7-2.4,1.3-3.5h1.5c0.5-0.9,1.2-1.6,2-2.3c0.9-0.8,2.1-1.3,3.3-1.5
			l0.3-0.5c0.4,0.1,0.8,0.4,1,0.7c0.3,0.4,0.3,0.8,0.2,1.3c-0.2,0.3-0.6,0.5-1,0.4c-1.6,0.1-3,1.1-3.8,2.6c-0.7,1.4-1.4,4.3-0.8,6
			c0.2,0.5,0.6,1,1.1,1.2c0.2,0.1,0.5,0.1,0.7,0.1c0.4,0,0.8-0.1,1.1-0.3c1.2-0.8,2.1-2.1,2.5-3.5l0-0.2c0.1-0.4,0.1-0.4-0.3-0.6
			c-0.1,0-0.2-0.1-0.3-0.2c-0.8-0.5-1.6-1.3-1.2-2.2c0.2-0.6,0.8-2.2,1.9-2.2h0.1c0.8,0.1,1.5,0.4,2.1,1l0.2,0.1
			c0.3,0.2,0.6,0.3,0.9,0.3c0.9-0.1,1.7-0.5,2.3-1.2c0.8-0.9,1.6-2,2.2-3c0.2-0.4,0.4-0.8,0.9-0.8c0.2,0,0.4,0.1,0.6,0.2
			c1,0.5,1.5,0.9,1.6,1.3c0.1,0.6,0.1,1.2-0.1,1.7c-0.1,0.3-0.2,0.7-0.2,1l0.1-0.2c1-1.5,2.1-2.8,3.3-4.1c1.3-1.3,2.2-2,3.2-2
			c0.5,0,1,0.2,1.4,0.5c1.5,0.9,2.3,1.5,1.5,3.2c-1,1.9-1.8,4-2.3,6.1c0,0.5-0.1,1.1,0.3,1.1c0.4-0.1,0.8-0.3,1.1-0.6
			c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.2,0.9,0.5c0.5,0.5,0.6,1.3,0.2,1.9c-0.9,1.4-2,2.7-3.3,3.8c-0.1,0.2-0.4,0.2-0.6,0.2
			c-0.5-0.1-0.9-0.3-1.2-0.7c-0.1-0.2-0.3-0.3-0.4-0.5c-1.2-1.2-1.7-2.9-1.4-4.6c0.3-1.5,0.8-3,1.3-4.4c0.2-0.5,0.3-0.7,0.1-0.7h0
			c-0.7,0-3.2,2.6-5,5.8c-0.9,1.6-1.7,3.3-2.4,5.1c-0.1,0.2-0.1,0.3-0.2,0.4l-0.1,0.1c-0.1,0.3-0.3,0.6-0.7,0.6c-0.1,0-0.1,0-0.2,0
			c-0.7-0.2-1.3-0.6-1.8-1.1c-0.5-0.4-0.6-1.1-0.5-1.7c0.1-0.5,0.8-2.9,1-3.9c0.1-0.7,0.2-1.2,0.3-1.5c-0.4,0.4-0.9,0.6-1.4,0.8
			c-0.6,0.2-1.1,0.4-1.7,0.5c0,0,0,0,0,0.1c-0.4,2.3-1.4,4.4-3,6.1c-1.7,1.6-2.9,2.2-4.8,2.2c-0.2,0-0.5,0-0.7,0
			c-1.4-0.3-2.6-1.2-3.2-2.5c-0.1-0.3-0.2-0.5-0.3-0.7c-0.1-0.2-0.2-0.5-0.3-0.6c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0
			c-0.7,0.5-1.4,1.1-2.1,1.8c-0.6,0.6-1.4,1.2-2.2,2c-1.7,1.5-2.8,1.8-3.8,1.8c-0.3,0-0.7,0-1-0.1c-1-0.2-1.9-0.7-2.5-1.6
			c-0.2-0.3-0.2-0.6-0.1-0.9c0.3-0.8,0.8-1.6,1.3-2.4c0.1-0.2,0.3-0.3,0.6-0.3c0,0,0.1,0,0.1,0c0.2,0,0.5,0.2,0.7,0.7
			c0.2,0.4,0.5,0.6,0.9,0.7c0.1,0,0.1,0,0.2,0c0.4,0,0.8-0.2,1-0.5c0.8-0.9-0.1-2.8-0.6-3.9c-0.1-0.3-0.2-0.5-0.3-0.8
			c-0.3-0.8-0.7-1.5-0.9-1.5h0c-0.3,0-0.4,0.3-0.8,0.8c-0.1,0.2-0.3,0.4-0.5,0.7l-0.1,0.2c-3.6,5.2-6.5,8.5-8.4,9.6
			c-0.9,0.6-2,0.9-3.1,0.9c-1.6,0-3.2-0.9-4-2.3C58.5,42.8,58,41.4,58,40c-0.3,0.1-0.9,0.2-1.4,0.4s-1,0.2-1.2,0.2
			c-0.1,0-0.1,0.1-0.1,0.1c-0.4,2.5-1.7,4.8-3.7,6.4C50.5,48,49.1,48.6,47.7,48.6 M50.2,35c-0.7,0-1.7,0.3-2.6,2
			c-1.6,2.8-1.7,5.8-0.2,6.8c0.3,0.2,0.6,0.3,1,0.3c0.2,0,0.4,0,0.6-0.1c1.1-0.4,2.1-1.3,2.6-2.4l0,0l0-0.1c0.3-0.5,0.5-1,0.7-1.6
			c0.1-0.3-0.1-0.6-0.3-0.7c0,0,0,0,0,0c-1-0.5-1.9-1.5-1.6-2.4c0.2-0.7,0.5-1.4,0.6-1.6c0,0,0,0,0-0.1C50.6,35.1,50.4,35,50.2,35
			 M68.5,23c-0.7,0-2,0.8-3.7,3.7c-1.4,2.3-2.3,4.9-2.9,7.5c1.7-1.5,3.3-3.3,4.5-5.2c2.2-3,2.7-4.9,2.5-5.6c0-0.1-0.1-0.2-0.2-0.3
			C68.6,23,68.6,23,68.5,23"
                    />
                    <path
                        id="Tracé_1621"
                        fill="#1A1616"
                        d="M76.1,31.1c-0.5,0-0.8,0-0.9,0c-0.2,0-0.4,0-0.6-0.1c1.4-2.1,1.9-2.6,3.1-2.6h0.1
			c0.4,0,0.8,0.1,1.1,0.4c0,0.1,0.1,0.1,0.1,0.2h-0.1h-0.1C77.7,29,77.2,29.4,76.1,31.1 M86.2,31.1c0.6-1.1,1.4-2.1,2.4-2.9
			c1-0.9,2.3-1.5,3.7-1.6c0.2,0,0.4,0,0.7,0.1c0.1,0,0.2,0,0.3,0.1l-0.3,0.5c-1.2,0.2-2.3,0.7-3.3,1.5c-0.8,0.6-1.5,1.4-2,2.3
			L86.2,31.1 M67.2,20.3l-0.6-1.1c1.9-1.8,3.5-2.5,4.7-2.5c0.3,0,0.7,0.1,1,0.2c0.2,0.1,0.5,0.3,0.6,0.5c-0.2,0-0.4,0-0.5,0
			C71.1,17.4,69.2,18.2,67.2,20.3"
                    />
                    <path
                        id="Tracé_1622"
                        fill="#1B2F5F"
                        d="M96.3,18.4L89,5.7c-0.3-0.5-0.7-0.8-1.3-0.9c-0.4-0.5-1-0.8-1.6-0.8H71
			c-0.6,0-1.1,0.2-1.4,0.6l0,0l0,0c0,0,0,0,0,0l0,0l0,0l2-3.5c0.4-0.6,1-1,1.7-1h15.1C89,0,89.7,0.4,90,1l7.5,13.2
			c0.4,0.6,0.4,1.4,0,2L96.3,18.4"
                    />
                    <path
                        id="Tracé_1623"
                        fill="#1A1616"
                        d="M95.6,19.7L95.6,19.7C95.5,19.7,95.5,19.6,95.6,19.7L95.6,19.7c0.1-0.6,0.1-1.1-0.2-1.6
			L87.8,4.9c0,0-0.1-0.1-0.1-0.1c0.5,0.1,1,0.5,1.3,0.9l7.3,12.7L95.6,19.7C95.6,19.7,95.6,19.7,95.6,19.7"
                    />
                    <path
                        id="Tracé_1624"
                        fill="#1B2E5F"
                        d="M45.3,63.6c-1.3,0.2-2.5-0.8-2.7-2.1c0-0.1,0-0.1,0-0.2v-6.8c0.1-1.3,1.2-2.4,2.5-2.3
			c0.1,0,0.1,0,0.2,0c1.3-0.2,2.5,0.8,2.6,2c0,0.1,0,0.2,0,0.2v0.9c0,0.2-0.1,0.2-1,0.2c-0.6,0-0.9,0-0.9-0.2v-0.8
			c0-0.4-0.3-0.7-0.7-0.7c-0.6,0-0.7,0.5-0.7,0.9V61c0,0.5,0.1,0.9,0.7,0.9c0.3,0,0.7-0.2,0.7-0.6c0,0,0-0.1,0-0.1v-0.8
			c0-0.2,0.2-0.2,1-0.2c0.8,0,0.9,0,0.9,0.3v0.8C47.9,62.7,47,63.6,45.3,63.6L45.3,63.6z"
                    />
                    <path
                        id="Tracé_1625"
                        fill="#A71421"
                        d="M51.9,56.4c0-0.1,0-0.4-0.2-0.4c-0.1,0-0.1,0.4-0.1,0.5c-0.1,1.3-0.2,2.1-0.2,3.1
			c0,0.1,0.1,0.1,0.4,0.1c0.2,0,0.4,0,0.4-0.1C52,58.4,52,57.7,51.9,56.4L51.9,56.4z M53.6,63.6c-0.5,0-0.9,0-0.9-0.2
			c-0.1-0.9-0.2-1.5-0.4-2.4c0-0.2-0.2-0.1-0.5-0.1c-0.4,0-0.5,0-0.6,0.1c-0.1,0.9-0.2,1.5-0.3,2.4c0,0.2-0.4,0.2-1,0.2
			c-0.3,0-0.9,0-0.9-0.1c0.7-4.2,1.2-7.1,1.8-11c0-0.2,0.6-0.2,1-0.2c0.5,0,1,0,1,0.3c0.7,4.2,1.1,6.7,1.9,10.9
			C54.6,63.7,54.1,63.6,53.6,63.6L53.6,63.6z"
                    />
                    <path
                        id="Tracé_1626"
                        fill="#1B2E5F"
                        d="M60.6,63.6c-0.5,0-0.7,0-0.8-0.4c-0.6-1.9-0.8-2.7-1.5-4.8c-0.1-0.4-0.3-1-0.4-1
			s-0.1,0.3-0.1,0.6v5.3c0,0.3-0.1,0.3-1,0.3c-0.9,0-0.9,0-0.9-0.3V52.5c0-0.2,0-0.2,0.9-0.2c0.8,0,0.9,0.1,1,0.5
			c0.4,1.3,0.9,3.1,1.5,4.8c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.1-0.3,0.1-0.5v-4.9c0-0.3,0.1-0.3,1-0.3c0.9,0,1,0,1,0.3v10.6
			C61.5,63.6,61.5,63.6,60.6,63.6L60.6,63.6z"
                    />
                    <path
                        id="Tracé_1627"
                        fill="#A71421"
                        d="M65.6,56.4c0-0.1,0-0.4-0.2-0.4c-0.1,0-0.1,0.4-0.1,0.5c-0.1,1.3-0.2,2.1-0.2,3.1
			c0,0.1,0.1,0.1,0.4,0.1c0.2,0,0.4,0,0.4-0.1C65.8,58.4,65.7,57.7,65.6,56.4L65.6,56.4z M67.3,63.6c-0.5,0-0.9,0-0.9-0.2
			c-0.1-0.9-0.2-1.5-0.4-2.4c0-0.2-0.2-0.1-0.5-0.1c-0.4,0-0.5,0-0.6,0.1c-0.1,0.9-0.2,1.5-0.3,2.4c0,0.2-0.4,0.2-1,0.2
			c-0.3,0-0.9,0-0.9-0.1c0.7-4.2,1.2-7.1,1.8-11c0-0.2,0.6-0.2,1-0.2c0.5,0,1,0,1,0.3c0.7,4.2,1.1,6.7,1.9,10.9
			C68.4,63.7,67.8,63.6,67.3,63.6L67.3,63.6z"
                    />
                    <path
                        id="Tracé_1628"
                        fill="#1B2E5F"
                        d="M73,55.1c0-0.3,0-0.6-0.2-0.9C72.6,54,72.3,54,72.1,54c-0.3,0-0.4,0-0.5,0.1
			c0,0.1-0.1,0.1-0.1,0.2v7.3c0,0.1,0,0.3,0.1,0.3c0.1,0,0.3,0,0.4,0c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.2-0.5,0.2-0.8L73,55.1
			L73,55.1z M74.2,63c-0.6,0.5-1.4,0.7-2.1,0.7h-1.9c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.1-0.3-0.1-0.4V52.8c0-0.1,0-0.3,0.1-0.4
			c0.1-0.1,0.2-0.1,0.5-0.1H72c0.8,0,1.6,0.2,2.2,0.7c0.5,0.4,0.8,1.1,0.8,1.8v6.4C75,61.9,74.7,62.5,74.2,63L74.2,63z"
                    />
                    <path
                        id="Tracé_1629"
                        fill="#A71421"
                        d="M77.5,63.6c-0.9,0-0.9,0-0.9-0.2V52.6c0-0.2,0.1-0.3,0.9-0.3c1,0,1,0,1,0.3v10.8
			C78.5,63.6,78.5,63.6,77.5,63.6z"
                    />
                    <path
                        id="Tracé_1630"
                        fill="#1B2E5F"
                        d="M82.6,56.4c0-0.1,0-0.4-0.2-0.4c-0.1,0-0.1,0.4-0.1,0.5c-0.1,1.3-0.2,2.1-0.2,3.1
			c0,0.1,0.1,0.1,0.4,0.1c0.2,0,0.4,0,0.4-0.1C82.8,58.4,82.7,57.7,82.6,56.4L82.6,56.4z M84.3,63.6c-0.5,0-0.9,0-0.9-0.2
			c-0.1-0.9-0.2-1.5-0.4-2.4c0-0.2-0.2-0.1-0.5-0.1c-0.4,0-0.5,0-0.6,0.1c-0.1,0.9-0.2,1.5-0.3,2.4c0,0.2-0.4,0.2-1,0.2
			c-0.3,0-0.9,0-0.9-0.1c0.7-4.2,1.2-7.1,1.8-11c0-0.2,0.6-0.2,1-0.2c0.5,0,1,0,1,0.3c0.7,4.2,1.1,6.7,1.9,10.9
			C85.4,63.7,84.8,63.6,84.3,63.6L84.3,63.6z"
                    />
                    <path
                        id="Tracé_1631"
                        fill="#A71421"
                        d="M91.3,63.6c-0.5,0-0.7,0-0.8-0.4c-0.6-1.9-0.8-2.7-1.5-4.8c-0.1-0.4-0.3-1-0.4-1
			s-0.1,0.3-0.1,0.6v5.3c0,0.3-0.1,0.3-1,0.3c-0.9,0-0.9,0-0.9-0.3V52.5c0-0.2,0-0.2,0.9-0.2c0.8,0,0.9,0.1,1,0.5
			c0.4,1.3,0.9,3.1,1.5,4.8c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.1-0.3,0.1-0.5v-4.9c0-0.3,0.1-0.3,1-0.3c0.9,0,1,0,1,0.3v10.6
			C92.3,63.6,92.3,63.6,91.3,63.6L91.3,63.6z"
                    />
                    <path
                        id="Tracé_1632"
                        fill="#1B2E5F"
                        d="M93.3,52.1c0.1,0,0.2,0,0.2-0.1c0-0.1-0.1-0.1-0.2-0.1h-0.2v0.2L93.3,52.1z M93.3,52.2
			h-0.1v0.3h-0.1v-0.8h0.3c0.2,0,0.3,0.1,0.3,0.2c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0l0.2,0.3h-0.2L93.3,52.2L93.3,52.2z M93.3,52.7
			c0.3,0,0.5-0.2,0.5-0.5c0,0,0,0,0,0c0-0.3-0.2-0.5-0.5-0.5c0,0,0,0,0,0c-0.3,0-0.5,0.2-0.5,0.5c0,0,0,0,0,0
			C92.8,52.5,93,52.7,93.3,52.7C93.3,52.7,93.3,52.7,93.3,52.7z M93.3,51.5c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0
			c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7C92.7,51.8,93,51.5,93.3,51.5z"
                    />
                    <path
                        id="Tracé_1633"
                        fill="#1B2E5F"
                        d="M97.9,62.2v1.2c0,0.1,0,0.2,0,0.2s-0.1,0-0.2,0h-3.6c-0.1,0-0.1,0-0.1-0.3
			c0-0.3,0-0.4,0.1-0.4h3.1c0.1,0,0.2,0,0.2,0c0-0.1,0-0.1,0-0.2v-0.6c0-0.1,0-0.1,0.3-0.1C97.9,62.1,97.9,62.1,97.9,62.2L97.9,62.2
			z"
                    />
                    <path
                        id="Tracé_1634"
                        fill="#1B2E5F"
                        d="M95.4,60.6c0,0-0.2,0-0.2,0.1s0.1,0,0.2,0c0.4,0,0.7,0.1,1.1,0.1c0,0,0,0,0-0.1
			s0-0.1,0-0.1C96.1,60.5,95.9,60.5,95.4,60.6L95.4,60.6z M97.9,60c0,0.2,0,0.3-0.1,0.3c-0.3,0.1-0.5,0.1-0.8,0.1
			c-0.1,0,0,0.1,0,0.2c0,0.1,0,0.2,0,0.2c0.3,0,0.5,0.1,0.9,0.1c0.1,0,0.1,0.1,0.1,0.4c0,0.1,0,0.3-0.1,0.3
			c-1.5-0.2-2.5-0.4-3.8-0.6C94,61,94,60.8,94,60.6c0-0.2,0-0.3,0.1-0.3c1.4-0.3,2.3-0.4,3.8-0.7C97.9,59.6,97.9,59.8,97.9,60
			L97.9,60z"
                    />
                    <path
                        id="Tracé_1635"
                        fill="#1B2E5F"
                        d="M97.9,57.2c0,0,0,0.1,0,0.1c0,0.1-0.2,0.1-0.2,0.2s0.2,0.1,0.2,0.6
			c0.1,0.5-0.3,0.9-0.7,0.9c0,0,0,0-0.1,0h-2.4c-0.5,0-0.8-0.4-0.8-0.9c0,0,0,0,0,0c-0.1-0.5,0.3-0.9,0.7-0.9c0,0,0,0,0.1,0h0.3
			c0.1,0,0.1,0.1,0.1,0.4c0,0.2,0,0.3-0.1,0.3c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.2,0.2c0,0.2,0.2,0.2,0.3,0.2H97
			c0.1,0,0.3,0,0.3-0.2c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-0.7c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0-0.1,0-0.2,0
			s-0.2,0-0.2,0c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.3,0-0.3,0.1-0.3h1.8C97.8,57.2,97.9,57.2,97.9,57.2L97.9,57.2z"
                    />
                    <path
                        id="Tracé_1636"
                        fill="#1B2E5F"
                        d="M97.9,55v1.2c0,0.1,0,0.2,0,0.3s-0.1,0-0.2,0h-3.6c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1V55
			c0-0.1,0-0.1,0.3-0.1c0.3,0,0.3,0,0.3,0.1v0.6c0,0.1,0,0.1,0,0.1c0,0,0,0,0.1,0h0.7c0.1,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1v-0.3
			c0-0.1,0-0.1,0.3-0.1s0.3,0,0.3,0.1v0.3c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0,0.2,0h0.8c0.1,0,0.2,0,0.2,0c0-0.1,0-0.1,0-0.2V55
			c0-0.1,0-0.1,0.3-0.1S97.9,54.9,97.9,55L97.9,55z"
                    />
                    <path
                        id="Tracé_1637"
                        fill="#1B2E5F"
                        d="M95,53.1c-0.1,0-0.2,0-0.3,0.1c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.1c0,0,0,0,0.1,0h0.8
			c0.1,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.1L95,53.1z M97.9,52.7c0,0.3,0,0.3-0.1,0.3h-1.3
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0,0.3,0.1,0.3h1.6c0.1,0,0.1,0.1,0.1,0.4c0,0.3,0,0.3-0.1,0.3h-3.7c0,0-0.1,0-0.1,0
			c0,0,0-0.1,0-0.2v-0.6c0-0.3,0.1-0.5,0.2-0.8c0.2-0.2,0.4-0.3,0.6-0.3h0.5c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.2,0.3
			c0,0,0-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.4-0.1h1.4C97.9,52.4,97.9,52.4,97.9,52.7L97.9,52.7z"
                    />
                    <path
                        id="Tracé_1638"
                        fill="#A71421"
                        d="M90.4,46.2c-0.3,0.7-0.7-1.4-0.9-1.4c-0.1,0-0.3,0.7-0.4,0.9c-0.2,0.8-0.5,0.4-0.5,0.4
			c0,0-0.1,0-0.1,0.2c-0.1,0.7,0,1.2-0.9,0.7c-0.3,0.3,1.2,2.5-0.3,1.8c-0.1-0.1-0.3-0.2-0.4-0.3c0,0-0.1,0.1-0.2,0.2
			c-0.3,0.1-0.9-0.2-1.1-0.3c-0.1-0.1-0.5-0.4-0.4-0.1c0.1,0.2,0.5,0.8,0.2,1.1c-0.1,0.1,0.4,0.6,0.6,0.7c0.3,0.2-0.4,0.4-0.4,0.4
			c0.1,0.2,1.9,0.6,1.1,1.1h5.7c-0.1,0-0.2-0.1-0.2-0.2c0-0.4,0.9-0.4,1.1-0.6c-0.4-0.3-0.2-0.5,0.1-0.8c-0.2-0.4,0.2-0.5,0.3-1
			c0.1-0.4,0-0.9-0.1-0.7c-0.1,0.2-0.3,0.7-0.6,0.5c-0.1,0,0-0.1-0.1-0.2c-0.5,0.2-0.9,0.3-1.4,0.4c-1.5,0.2,0.2-1.6-0.1-1.9
			c-0.9,0.5-0.9-0.6-0.9-0.7S90.4,46.1,90.4,46.2"
                    />
                    <path
                        id="Tracé_1639"
                        fill="#FFFFFF"
                        d="M88.1,48.3c0-0.3-0.1-0.6-0.2-0.9c0.6,0.2,0.7-0.5,0.8-1c0.6,0.1,0.5-0.6,0.6-0.9
			c-0.2,0.1-0.1,1.1-0.7,0.8c-0.1,0.5-0.1,1.3-0.9,0.9C87.8,47.5,88,48.2,88.1,48.3L88.1,48.3z M87.2,48.9c-0.1-0.1-0.2-0.2-0.3-0.2
			c-0.4,0.4-1.3-0.1-1.6-0.3c0.2,0.3,1.2,0.8,1.6,0.4c0.2,0.2,0.5,0.3,0.8,0.4C87.9,49.2,87.5,49.1,87.2,48.9L87.2,48.9z"
                    />
                </g>

                <linearGradient
                    id="Tracé_1640_00000166669059261443919810000015347256874741447065_"
                    gradientUnits="userSpaceOnUse"
                    x1="-2293.1021"
                    y1="-824.0941"
                    x2="-2293.1021"
                    y2="-823.0941"
                    gradientTransform="matrix(176.139 0 0 -47 402569.25 -40060.3633)"
                >
                    <stop offset="0" style={{ stopColor: '#A71421', stopOpacity:0.502 }} />
                    <stop offset="1" style={{ stopColor: '#FFFFFF', stopOpacity:0 }} />
                </linearGradient>
                <path
                    id="Tracé_1640"
                    fill="url(#Tracé_1640_00000166669059261443919810000015347256874741447065_)"
                    d="M-1336.3-1338.9
		c36.3,0,68.5,4.3,88.8,11v-47h-176.1v46.5C-1403.2-1334.8-1371.7-1338.9-1336.3-1338.9z"
                />
                <path
                    id="Tracé_1641"
                    fill="#FFFFFF"
                    d="M-1335.9-1340c35.6,0,67.2,3.6,87.1,9.3v-39.7h-172.8v39.3
		C-1401.5-1336.6-1370.6-1340-1335.9-1340z"
                />
                <g id="Groupe_812" transform="translate(-1415.271 -1366.969)">
                    <path
                        id="Tracé_1642"
                        fill="#1B2F5F"
                        d="M13.8,0H0c0,10.8,0,21.7,0,32.5c2.3-0.4,4.7-0.7,7-1.1c0-3.6,0-7.3,0-10.9
			c2.2-0.2,4.5-0.4,6.7-0.6c2.2-0.8,3.7-2.9,3.5-5.3c0-3.2,0-6.4,0-9.6C17.3,1.8,15.8,0.7,13.8,0z M10.2,14.2l-0.4,0.5
			c-0.9,0.1-1.8,0.1-2.7,0.2c0-3.1,0-6.1,0-9.2l2.7-0.1L10.2,6C10.2,8.8,10.2,11.5,10.2,14.2L10.2,14.2z"
                    />
                    <path
                        id="Tracé_1643"
                        fill="#1B2F5F"
                        d="M32.6,12.1c0-1.6,0-3.2,0-4.8c0.2-1.8-1-3.4-2.8-3.8c-3.7,0-7.4,0.1-11.1,0.1
			c0,8,0,15.9-0.1,23.9c1.9-0.2,3.8-0.4,5.7-0.6c0-3,0-6.1,0-9.1l0.6,0c1.1,3,2.2,5.9,3.2,8.8c1.7-0.2,3.3-0.3,5-0.4
			c0-1.1,0-2.1,0-3.2c-1-2.3-2-4.7-3-7.1C31.8,15.3,32.7,13.7,32.6,12.1z M26.9,13.2l-0.4,0.3l-2.1,0.1c0-1.9,0-3.9,0-5.8l2.1-0.1
			L26.9,8C26.9,9.8,26.9,11.5,26.9,13.2L26.9,13.2z"
                    />
                    <path
                        id="Tracé_1644"
                        fill="#1B2F5F"
                        d="M39.9,16.7c1.9-0.1,3.8-0.2,5.7-0.2c0-1.5,0-3,0-4.6C43.7,11.9,41.9,12,40,12
			c0-1.3,0-2.7,0-4c2,0,4-0.1,6-0.1c0-1.5,0-3,0-4.6c-3.9,0-7.8,0.1-11.7,0.1c0,7.5-0.1,15.1-0.1,22.6c4-0.3,7.9-0.6,11.9-0.9
			c0-1.5,0-3,0-4.6c-2.1,0.1-4.1,0.2-6.2,0.3C39.9,19.5,39.9,18.1,39.9,16.7z"
                    />
                    <path
                        id="Tracé_1645"
                        fill="#1B2F5F"
                        d="M59,3.3c-3.7,0-7.4,0-11.1,0.1c0,7.3,0,14.5-0.1,21.8c3.7-0.2,7.4-0.4,11.1-0.5
			c1.7-0.3,2.9-1.9,2.8-3.6c0-4.7,0-9.4,0-14.1C61.9,5.1,60.7,3.5,59,3.3z M56.1,20.5l-0.4,0.3c-0.7,0-1.4,0.1-2.1,0.1
			c0-4.6,0-9.2,0-13.7l2.1,0l0.4,0.3C56.1,11.8,56.1,16.1,56.1,20.5z"
                    />
                    <path
                        id="Tracé_1646"
                        fill="#1B2F5F"
                        d="M63.5,7.6l1.1,0c0,4.1,0,8.2,0,12.3l-1.1,0c0,1.5,0,2.9,0,4.4c2.6-0.1,5.2-0.1,7.8-0.2
			c0-1.5,0-2.9,0-4.4l-1.1,0c0-4.1,0-8.2,0-12.3l1.1,0c0-1.5,0-2.9,0-4.4c-2.6,0-5.2,0-7.8,0C63.5,4.7,63.5,6.2,63.5,7.6z"
                    />
                    <path
                        id="Tracé_1647"
                        fill="#1B2F5F"
                        d="M81.3,15.6c0,1.5,0,2.9,0,4.4l-0.4,0.3h-1.8l-0.4-0.3c0-4.3,0-8.5,0-12.8L79.1,7h1.8
			l0.4,0.3c0,1.5,0,3,0,4.5c1.9,0,3.8,0,5.7,0c0-1.7,0-3.4,0-5.1c0-2.2-1.2-3-2.8-3.5c-2.8,0-5.5,0-8.3,0c-1.6,0.5-2.8,1.3-2.8,3.5
			c0,4.7,0,9.3,0,14c0,2.2,1.2,3,2.8,3.5c2.8,0,5.5,0,8.3,0c1.6-0.5,2.8-1.3,2.8-3.5c0-1.7,0-3.3,0-5C85.1,15.7,83.2,15.6,81.3,15.6
			z"
                    />
                    <path
                        id="Tracé_1648"
                        fill="#1B2F5F"
                        d="M101.8,3.3c-4.6,0-9.2,0-13.8,0c0,1.5,0,2.9,0,4.4c1.4,0,2.7,0,4.1,0
			c0,5.6,0,11.1,0,16.7c1.9,0,3.8,0.1,5.7,0.1c0-5.6,0-11.2,0-16.8c1.4,0,2.7,0,4.1,0C101.8,6.2,101.8,4.7,101.8,3.3z"
                    />
                    <path
                        id="Tracé_1649"
                        fill="#1B2F5F"
                        d="M109.7,20.4c0-4.2,0-8.4,0-12.6l1.1,0l0-4.5c-2.6,0-5.2,0-7.8,0c0,1.5,0,3,0,4.4l1.1,0
			c0,4.2,0,8.3,0,12.5l-1.1,0c0,1.5,0,3,0,4.4c2.6,0.1,5.2,0.2,7.8,0.4c0-1.5,0-3,0-4.5L109.7,20.4z"
                    />
                    <path
                        id="Tracé_1650"
                        fill="#1B2F5F"
                        d="M123.5,3.4c-2.8,0-5.5-0.1-8.3-0.1c-1.7,0.3-2.9,1.9-2.8,3.6c0,4.8,0,9.7,0,14.5
			c-0.1,1.8,1.1,3.4,2.8,3.8c2.8,0.2,5.5,0.4,8.3,0.6c1.7-0.2,3-1.8,2.8-3.5c0,0,0,0,0,0c0-5,0-10-0.1-15
			C126.5,5.4,125.3,3.8,123.5,3.4z M120.3,21.6c-0.6,0-1.2-0.1-1.8-0.1l-0.4-0.3c0-4.5,0-9,0-13.5l0.4-0.3l1.8,0l0.4,0.3
			c0,4.5,0,9,0,13.6L120.3,21.6z"
                    />
                    <path
                        id="Tracé_1651"
                        fill="#1B2F5F"
                        d="M136.9,3.6c0,3.4,0,6.8,0,10.2l-0.4,0c-1.2-3.5-2.4-6.9-3.6-10.2l-5-0.1
			c0,7.6,0.1,15.1,0.1,22.7c1.7,0.1,3.3,0.3,5,0.4c0-3.4,0-6.7,0-10.1l0.4,0c1.2,3.4,2.4,6.9,3.6,10.4c1.7,0.2,3.3,0.3,5,0.5
			c0-8,0-15.9-0.1-23.9L136.9,3.6z"
                    />
                    <path
                        id="Tracé_1652"
                        fill="#1B2F5F"
                        d="M153.4,5.7l0.4,0.4c0,1.7,0,3.3,0,5c2.4,0.1,4.7,0.2,7.1,0.4v-6c0-3.4-1.5-4.7-3.5-5.4
			h-10.4c-1.9,0.7-3.5,1.8-3.4,5c0,2.1,0,4.2,0,6.3c0,2.3,0.3,3.7,2.5,4.8c2.4,1.2,4.9,2.5,7.3,3.8l0.4,0.6c0,1.6,0,3.2,0,4.8
			l-0.4,0.4c-0.7-0.1-1.5-0.2-2.2-0.3l-0.4-0.5c0-1.8,0-3.5,0-5.3c-2.4-0.2-4.7-0.4-7.1-0.6c0,2,0,4,0,5.9c-0.2,2.4,1.2,4.6,3.5,5.4
			c3.4,0.5,6.9,0.9,10.3,1.5c1.9-0.4,3.4-1.4,3.4-4.9v-7.4c0-2.4-0.3-4.1-2.5-5.1c-2.4-1.1-4.7-2.2-7.1-3.3l-0.6-0.7
			c0-1.5,0-3,0-4.5l0.4-0.4L153.4,5.7z"
                    />
                </g>
                <g id="Groupe_813" transform="translate(-1415.271 -1366.969)">
                    <linearGradient
                        id="Tracé_1653_00000073679742419300071600000015611153517092146086_"
                        gradientUnits="userSpaceOnUse"
                        x1="-862.1472"
                        y1="540.8075"
                        x2="-862.1472"
                        y2="541.8075"
                        gradientTransform="matrix(17.2579 0 0 -32.494 14887.5068 17605.502)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1653"
                        fill="url(#Tracé_1653_00000073679742419300071600000015611153517092146086_)"
                        d="M13.8,0H0
			c0,10.8,0,21.7,0,32.5c2.3-0.4,4.7-0.7,7-1.1c0-3.6,0-7.3,0-10.9c2.2-0.2,4.5-0.4,6.7-0.6c2.2-0.8,3.7-2.9,3.5-5.3
			c0-3.2,0-6.4,0-9.6C17.3,1.8,15.8,0.7,13.8,0z M10.2,14.2l-0.4,0.5c-0.9,0.1-1.8,0.1-2.7,0.2c0-3.1,0-6.1,0-9.2l2.7-0.1L10.2,6
			C10.2,8.8,10.2,11.5,10.2,14.2L10.2,14.2z"
                    />

                    <linearGradient
                        id="Tracé_1654_00000096056113536937828730000012530469229842676134_"
                        gradientUnits="userSpaceOnUse"
                        x1="-858.8156"
                        y1="538.4548"
                        x2="-858.8156"
                        y2="539.4548"
                        gradientTransform="matrix(14.4829 0 0 -24.048 12464.1387 12976.3018)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1654"
                        fill="url(#Tracé_1654_00000096056113536937828730000012530469229842676134_)"
                        d="M32.6,12.1
			c0-1.6,0-3.2,0-4.8c0.2-1.8-1-3.4-2.8-3.8c-3.7,0-7.4,0.1-11.1,0.1c0,8,0,15.9-0.1,23.9c1.9-0.2,3.8-0.4,5.7-0.6c0-3,0-6.1,0-9.1
			l0.6,0c1.1,3,2.2,5.9,3.2,8.8c1.7-0.2,3.3-0.3,5-0.4c0-1.1,0-2.1,0-3.2c-1-2.3-2-4.7-3-7.1C31.8,15.3,32.7,13.7,32.6,12.1z
			 M26.9,13.2l-0.4,0.3l-2.1,0.1c0-1.9,0-3.9,0-5.8l2.1-0.1L26.9,8C26.9,9.8,26.9,11.5,26.9,13.2L26.9,13.2z"
                    />

                    <linearGradient
                        id="Tracé_1655_00000170274775205484962470000007699600304495832486_"
                        gradientUnits="userSpaceOnUse"
                        x1="-854.2994"
                        y1="537.9203"
                        x2="-854.2994"
                        y2="538.9203"
                        gradientTransform="matrix(11.891 0 0 -22.707 10198.6592 12240.6211)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1655"
                        fill="url(#Tracé_1655_00000170274775205484962470000007699600304495832486_)"
                        d="M39.9,16.7
			c1.9-0.1,3.8-0.2,5.7-0.2c0-1.5,0-3,0-4.6C43.7,11.9,41.9,12,40,12c0-1.3,0-2.7,0-4c2,0,4-0.1,6-0.1c0-1.5,0-3,0-4.6
			c-3.9,0-7.8,0.1-11.7,0.1c0,7.5-0.1,15.1-0.1,22.6c4-0.3,7.9-0.6,11.9-0.9c0-1.5,0-3,0-4.6c-2.1,0.1-4.1,0.2-6.2,0.3
			C39.9,19.5,39.9,18.1,39.9,16.7z"
                    />

                    <linearGradient
                        id="Tracé_1656_00000091732479903223561690000013185298652339746220_"
                        gradientUnits="userSpaceOnUse"
                        x1="-857.9331"
                        y1="537.5339"
                        x2="-857.9331"
                        y2="538.5339"
                        gradientTransform="matrix(13.8912 0 0 -21.827 11972.5918 11757.8477)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1656"
                        fill="url(#Tracé_1656_00000091732479903223561690000013185298652339746220_)"
                        d="M59,3.3
			c-3.7,0-7.4,0-11.1,0.1c0,7.3,0,14.5-0.1,21.8c3.7-0.2,7.4-0.4,11.1-0.5c1.7-0.3,2.9-1.9,2.8-3.6c0-4.7,0-9.4,0-14.1
			C61.9,5.1,60.7,3.5,59,3.3z M56.1,20.5l-0.4,0.3c-0.7,0-1.4,0.1-2.1,0.1c0-4.6,0-9.2,0-13.7l2.1,0l0.4,0.3
			C56.1,11.8,56.1,16.1,56.1,20.5z"
                    />

                    <linearGradient
                        id="Tracé_1657_00000094589936158534479580000004383422389683965324_"
                        gradientUnits="userSpaceOnUse"
                        x1="-841.1967"
                        y1="537.2283"
                        x2="-841.1967"
                        y2="538.2283"
                        gradientTransform="matrix(7.827 0 0 -21.178 6651.4966 11401.7959)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1657"
                        fill="url(#Tracé_1657_00000094589936158534479580000004383422389683965324_)"
                        d="M63.5,7.6l1.1,0
			c0,4.1,0,8.2,0,12.3l-1.1,0c0,1.5,0,2.9,0,4.4c2.6-0.1,5.2-0.1,7.8-0.2c0-1.5,0-2.9,0-4.4l-1.1,0c0-4.1,0-8.2,0-12.3l1.1,0
			c0-1.5,0-2.9,0-4.4c-2.6,0-5.2,0-7.8,0C63.5,4.7,63.5,6.2,63.5,7.6z"
                    />

                    <linearGradient
                        id="Tracé_1658_00000034800144058251570960000015312781436080003741_"
                        gradientUnits="userSpaceOnUse"
                        x1="-857.8685"
                        y1="537.1154"
                        x2="-857.8685"
                        y2="538.1154"
                        gradientTransform="matrix(13.8499 0 0 -20.948 11961.3857 11275.6387)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1658"
                        fill="url(#Tracé_1658_00000034800144058251570960000015312781436080003741_)"
                        d="M81.3,15.6
			c0,1.5,0,2.9,0,4.4l-0.4,0.3h-1.8l-0.4-0.3c0-4.3,0-8.5,0-12.8L79.1,7h1.8l0.4,0.3c0,1.5,0,3,0,4.5c1.9,0,3.8,0,5.7,0
			c0-1.7,0-3.4,0-5.1c0-2.2-1.2-3-2.8-3.5c-2.8,0-5.5,0-8.3,0c-1.6,0.5-2.8,1.3-2.8,3.5c0,4.7,0,9.3,0,14c0,2.2,1.2,3,2.8,3.5
			c2.8,0,5.5,0,8.3,0c1.6-0.5,2.8-1.3,2.8-3.5c0-1.7,0-3.3,0-5C85.1,15.7,83.2,15.6,81.3,15.6z"
                    />

                    <linearGradient
                        id="Tracé_1659_00000168823464199983794330000017477521634050881947_"
                        gradientUnits="userSpaceOnUse"
                        x1="-857.8312"
                        y1="537.236"
                        x2="-857.8312"
                        y2="538.236"
                        gradientTransform="matrix(13.826 0 0 -21.194 11955.3359 11410.5664)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1659"
                        fill="url(#Tracé_1659_00000168823464199983794330000017477521634050881947_)"
                        d="M101.8,3.3
			c-4.6,0-9.2,0-13.8,0c0,1.5,0,2.9,0,4.4c1.4,0,2.7,0,4.1,0c0,5.6,0,11.1,0,16.7c1.9,0,3.8,0.1,5.7,0.1c0-5.6,0-11.2,0-16.8
			c1.4,0,2.7,0,4.1,0C101.8,6.2,101.8,4.7,101.8,3.3z"
                    />

                    <linearGradient
                        id="Tracé_1660_00000072253767192195146130000007163938143653418630_"
                        gradientUnits="userSpaceOnUse"
                        x1="-841.3575"
                        y1="537.4732"
                        x2="-841.3575"
                        y2="538.4732"
                        gradientTransform="matrix(7.86 0 0 -21.6951 6719.8696 11685.4707)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F' }}  />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1660"
                        fill="url(#Tracé_1660_00000072253767192195146130000007163938143653418630_)"
                        d="M109.7,20.4
			c0-4.2,0-8.4,0-12.6l1.1,0l0-4.5c-2.6,0-5.2,0-7.8,0c0,1.5,0,3,0,4.4l1.1,0c0,4.2,0,8.3,0,12.5l-1.1,0c0,1.5,0,3,0,4.4
			c2.6,0.1,5.2,0.2,7.8,0.4c0-1.5,0-3,0-4.5L109.7,20.4z"
                    />

                    <linearGradient
                        id="Tracé_1661_00000092456218166418355490000004310512736097374653_"
                        gradientUnits="userSpaceOnUse"
                        x1="-857.97"
                        y1="537.8141"
                        x2="-857.97"
                        y2="538.8141"
                        gradientTransform="matrix(13.915 0 0 -22.458 12058.0918 12104.0332)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F'}} />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1661"
                        fill="url(#Tracé_1661_00000092456218166418355490000004310512736097374653_)"
                        d="M123.5,3.4
			c-2.8,0-5.5-0.1-8.3-0.1c-1.7,0.3-2.9,1.9-2.8,3.6c0,4.8,0,9.7,0,14.5c-0.1,1.8,1.1,3.4,2.8,3.8c2.8,0.2,5.5,0.4,8.3,0.6
			c1.7-0.2,3-1.8,2.8-3.5c0,0,0,0,0,0c0-5,0-10-0.1-15C126.5,5.4,125.3,3.8,123.5,3.4z M120.3,21.6c-0.6,0-1.2-0.1-1.8-0.1l-0.4-0.3
			c0-4.5,0-9,0-13.5l0.4-0.3l1.8,0l0.4,0.3c0,4.5,0,9,0,13.6L120.3,21.6z"
                    />

                    <linearGradient
                        id="Tracé_1662_00000026842528578156974770000003082941898127323022_"
                        gradientUnits="userSpaceOnUse"
                        x1="-857.9125"
                        y1="538.4586"
                        x2="-857.9125"
                        y2="539.4586"
                        gradientTransform="matrix(13.878 0 0 -24.0579 12041.083 12981.6904)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F'}} />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1662"
                        fill="url(#Tracé_1662_00000026842528578156974770000003082941898127323022_)"
                        d="M136.9,3.6
			c0,3.4,0,6.8,0,10.2l-0.4,0c-1.2-3.5-2.4-6.9-3.6-10.2l-5-0.1c0,7.6,0.1,15.1,0.1,22.7c1.7,0.1,3.3,0.3,5,0.4c0-3.4,0-6.7,0-10.1
			l0.4,0c1.2,3.4,2.4,6.9,3.6,10.4c1.7,0.2,3.3,0.3,5,0.5c0-8,0-15.9-0.1-23.9L136.9,3.6z"
                    />

                    <linearGradient
                        id="Tracé_1663_00000046307311751864728200000002884163354491845810_"
                        gradientUnits="userSpaceOnUse"
                        x1="-862.1534"
                        y1="540.6958"
                        x2="-862.1534"
                        y2="541.6958"
                        gradientTransform="matrix(17.2641 0 0 -31.9612 15036.5635 17313.2402)"
                    >
                        <stop offset="0.645" style={{ stopColor: '#1B2F5F' }} />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.251 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1663"
                        fill="url(#Tracé_1663_00000046307311751864728200000002884163354491845810_)"
                        d="M153.4,5.7l0.4,0.4
			c0,1.7,0,3.3,0,5c2.4,0.1,4.7,0.2,7.1,0.4v-6c0-3.4-1.5-4.7-3.5-5.4h-10.4c-1.9,0.7-3.5,1.8-3.4,5c0,2.1,0,4.2,0,6.3
			c0,2.3,0.3,3.7,2.5,4.8c2.4,1.2,4.9,2.5,7.3,3.8l0.4,0.6c0,1.6,0,3.2,0,4.8l-0.4,0.4c-0.7-0.1-1.5-0.2-2.2-0.3l-0.4-0.5
			c0-1.8,0-3.5,0-5.3c-2.4-0.2-4.7-0.4-7.1-0.6c0,2,0,4,0,5.9c-0.2,2.4,1.2,4.6,3.5,5.4c3.4,0.5,6.9,0.9,10.3,1.5
			c1.9-0.4,3.4-1.4,3.4-4.9v-7.4c0-2.4-0.3-4.1-2.5-5.1c-2.4-1.1-4.7-2.2-7.1-3.3l-0.6-0.7c0-1.5,0-3,0-4.5l0.4-0.4L153.4,5.7z"
                    />
                </g>
                <g id="Groupe_814" transform="translate(-1346.635 -1305.199)">
                    <path
                        id="Tracé_1664"
                        fill="#1B2F5F"
                        d="M24.9,6.6c-1.3,2.2-6.3,3.8-12.4,3.8S1.3,8.8,0,6.6v4.1h0c0,0,0,0.1,0,0.1
			c0,2.6,5.6,4.7,12.4,4.7s12.4-2.1,12.4-4.7c0,0,0-0.1,0-0.1h0V6.6z"
                    />
                    <ellipse
                        id="Ellipse_162"
                        fill="#1B2F5F"
                        cx="12.4"
                        cy="4.7"
                        rx="12.4"
                        ry="4.7"
                    />

                    <linearGradient
                        id="Tracé_1665_00000106833728322752246240000009152900990536946358_"
                        gradientUnits="userSpaceOnUse"
                        x1="-935.1433"
                        y1="460.0378"
                        x2="-935.1433"
                        y2="461.0378"
                        gradientTransform="matrix(23.0341 0 0 -8.4699 21552.9883 3905.3315)"
                    >
                        <stop offset="0" style={{ stopColor: '#1C3264', stopOpacity:0.976 }} />
                        <stop offset="1" style={{ stopColor: '#3399FE', stopOpacity:0.502 }} />
                    </linearGradient>
                    <path
                        id="Tracé_1665"
                        fill="url(#Tracé_1665_00000106833728322752246240000009152900990536946358_)"
                        d="M14.5,0.4
			c4.1,0.5,7,2,7,3.6c0,2.1-4.7,3.8-10.5,3.8c-4.3,0-8-0.9-9.6-2.3c1.2,1.9,5.8,3.3,11.4,3.3c6.4,0,11.7-1.9,11.7-4.3
			C24.4,2.5,20.1,0.7,14.5,0.4z"
                    />
                </g>
            </g>
        </svg>
    );
}

NhlMolson.propTypes = propTypes;
NhlMolson.defaultProps = defaultProps;

export default NhlMolson;
